import React from 'react';
import PropTypes from 'prop-types';
import isFeedsFast from '../../utility/isFeedsFast';

import { isLoadKuaiBao } from '../../utility/PageConfigDataForShare';

import './ShareUserInfo.scss';

const ShareUserInfo = ({ onClick = () => {}, faceIcon, nickName, dayNum }) => {
  const isFF = isFeedsFast() || false;
  let btnText = isFF ? '在天天快报极速版等你' : '在QQ浏览器等你';

  // 拉新拉活快报
  const isKuaibao = isLoadKuaiBao();
  if (isKuaibao) {
    btnText = '在看点快报等你';
  }

  return (
    <div className="share-userinfo">
      {!!faceIcon && (
        <div className="G-img-wrap">
          <img src={faceIcon} alt="" />
        </div>
      )}
      <div className="main">
        {!!nickName && <div className="title">{nickName}</div>}
        <div className="desc">
          {btnText}
          {dayNum !== 0 && (
            <span>
              的第<span className="weight">{dayNum}天</span>
            </span>
          )}
        </div>
      </div>
      <div className={`btn ${isFF || isKuaibao ? 'is-kb' : ''}`} onClick={onClick}>
        去看看
      </div>
    </div>
  );
};
ShareUserInfo.propTypes = {
  onClick: PropTypes.func,
  faceIcon: PropTypes.string,
  nickName: PropTypes.string,
  dayNum: PropTypes.number,
};

export default ShareUserInfo;
